import React, { useEffect, useState } from 'react';
import { ReactComponent as VerifyAccountIcon } from 'assets/icons/verify-account.svg';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import { toast } from 'react-toastify';
import AuthService from 'services/auth.service';
import { handleApiError } from 'utils/functions';

const ManageProfilePassword = () => {
  const [timeLeft, setTimeLeft] = useState(30);
  const [resendCount, setResendCount] = useState(0);
  const email = localStorage.getItem('email');
  useEffect(() => {
    const timer = setTimeout(() => {
      if (timeLeft > 0) {
        setTimeLeft((prev) => prev - 1);
      }
    }, 1000);
    return () => clearTimeout(timer);
  }, [timeLeft]);
  useEffect(() => {
    resendLink();
  }, []);
  const resendLink = async () => {
    setResendCount(resendCount + 1);
    const payload = {
      dashboard_link: 'https://staging-business.getfoodcourt.com/profile/create-new-password',
      email: email
    };
    try {
      const res = await AuthService.forgotPassword(payload);
      if (res) {
        if (resendCount > 0) {
          toast(<ToastMessage type='success' message={'Link has been resent'} />);
        }
      }
    } catch (err) {
      handleApiError(err);
    }
  };

  return (
    <div className='mx-auto max-w-[360px]'>
      <VerifyAccountIcon className='mb-8' />

      <p className='text-[32px] mb-4 font-semibold'>Reset Password</p>
      <p className='text-[#6F7376] max-mb-[80px]'>
        A password reset link has been sent to
        <span className='text-[#0080E5] text-base font-medium mx-1'>{email}</span>
      </p>

      <div className='text-sm'>
        <p className='text-gray-5 mt-6'>
          Didn’t receive email?{' '}
          {timeLeft === 0 ? (
            <span
              className='underline text-medium cursor-pointer font-medium text-blue-4 hover:text-blue-5'
              onClick={() => {
                resendLink();
                setTimeLeft(30);
              }}>
              Resend
            </span>
          ) : (
            <span className='text-[#2E3031] pl-1 text-medium font-medium'>
              Resend in {timeLeft} seconds
            </span>
          )}
        </p>
      </div>
    </div>
  );
};

export default ManageProfilePassword;
